/**
 * Shared utilities for HTTP/OpenAPI layer.
 *
 * Kept framework-agnostic (no Hono imports) so they can be reused by the
 * OpenAPI spec-builder and the module router.
 */

import type { EntityDefinition } from '@gzl10/nexus-sdk'
import { resolveLocalized } from '@gzl10/nexus-sdk'

/**
 * Infer the sub-path where an entity router should mount.
 *
 * Heuristics (first match wins):
 *  1. `routePrefix` (explicit override, slash-normalized)
 *  2. `table` — strip 3-char plugin prefix (`usr_accounts` → `/accounts`)
 *  3. `key`
 *  4. fallback to kebab-cased localized label (EN)
 */
export function inferEntityRoutePath(definition: EntityDefinition): string {
  if ('routePrefix' in definition && definition.routePrefix !== undefined) {
    const routePrefix = definition.routePrefix as string
    return routePrefix.startsWith('/') ? routePrefix : `/${routePrefix}`
  }
  if ('table' in definition && definition.table) {
    const tableName = definition.table
    const parts = tableName.split('_')
    const name = parts.length > 1 ? parts.slice(1).join('_') : tableName
    return `/${name}`
  }
  if ('key' in definition && definition.key) {
    return `/${definition.key}`
  }
  return `/${resolveLocalized(definition.label, 'en').toLowerCase().replace(/\s+/g, '-')}`
}
